import { EFeatureType, IFeature } from "@/utilities/types/AdvanceFeature";
export const findFeatureByType = (
  features: IFeature[],
  featureType: EFeatureType
) => {
  return features.find((feature) => feature.type === featureType);
};
